import classnames from "classnames";

import {PropsWithClassName} from "@/lib/types/props.ts";

export const Hero = ({className}: PropsWithClassName) => (
  <div className={classnames("content-container text-center", className)}>
    <h2 className="pulseTextH2Bold pulse-color-gray-800 fs-1">You're almost there</h2>
    <span className="pulseTextBody pulse-color-gray-700">30-day money back guarantee.</span>
  </div>
);
